export function traverseVNode(vnodes) {
  const res = []
  for (const vnode of vnodes) {
    res.push(vnode)

    if (vnode.componentInstance) {
      res.push(...traverseVNode(vnode.componentInstance.$children.map(x => x.$vnode)))
    }

    if (vnode.children) {
      res.push(...traverseVNode(vnode.children))
    }
  }
  return res
}

export function flattenVNode(vnodes) {
  return traverseVNode(vnodes)
}

export function sortComponent(children, parent) {
  const { componentOptions } = parent.$vnode

  if (!componentOptions || !componentOptions.children || !componentOptions.children.length) {
    return
  }

  const vnodes = flattenVNode(componentOptions.children)
  children.sort((a, b) => vnodes.indexOf(a.$vode) - vnodes.indexOf(b.$vode))

  return children
}



// WEBPACK FOOTER //
// ./packages/utils/vue-extension.js